import * as yup from "yup";
import { FIELD_TYPES } from "./extra-fields/utils";
import { validateXPath } from "./xpath-validator";

export const buildValidationSchema = (
  baseSchema,
  extraFields,
  includeExtraFields
) => {
  if (!extraFields?.length || !includeExtraFields) return baseSchema;

  const fieldTypeSchemas = {
    [FIELD_TYPES.text]: yup.string(),
    [FIELD_TYPES.date]: yup.date(),
    [FIELD_TYPES.checkbox]: yup.boolean(),
  };

  let combinedSchema = yup.object().shape().concat(baseSchema);

  extraFields.forEach(
    ({ isActive, isRequired, fieldId, fieldType, validationRule }) => {
      let fieldSchema = fieldTypeSchemas[fieldType];

      if (isRequired && isActive) {
        fieldSchema = fieldSchema.required("Pole jest wymagane");
      }

      if (validationRule && isActive) {
        fieldSchema = fieldSchema.test(
          "validationRules",
          "Wystąpił błąd walidacji",
          function (value) {
            if (value === undefined || value === null) return true;
            return validateXPath(validationRule, fieldId, value);
          }
        );
      }

      combinedSchema = combinedSchema.concat(
        yup.object().shape({ [fieldId]: fieldSchema })
      );
    }
  );

  return combinedSchema;
};
